import React from 'react';

interface PublicLayoutProps {
  children: React.ReactNode;
}

/*
  Layout pubblico per le pagine viste dal cliente (es. /calendar/client/:id).
  Stile chiaro con i token del Task Radar:
  - pagina #FAFAFB, header incassato #F4F5F7
  - wordmark BYMARKE tinto inchiostro + sottotitolo "Social Dashboard"
  - niente toggle tema (dashboard sempre chiara)
  - header sticky con linea sottile, footer minimal
*/
const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#FAFAFB', color: '#13161C' }}
    >
      {/* Header — wordmark BYMARKE + Social Dashboard */}
      <header
        className="sticky top-0 z-50 backdrop-blur-lg"
        style={{
          backgroundColor: 'rgba(244,245,247,0.94)',
          borderBottom: '1px solid #EBEDF1',
        }}
        role="banner"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-3 sm:py-4">
          <div className="flex items-center justify-between gap-4">
            {/* Logo + sottotitolo impilati verticalmente */}
            <div className="flex flex-col items-start gap-1 sm:gap-1.5 min-w-0">
              <img
                src="/bymarke-wordmark-white.png"
                alt="ByMarke"
                className="h-5 sm:h-6 md:h-7 w-auto select-none"
                draggable={false}
                style={{ imageRendering: 'auto', filter: 'brightness(0)' }}
              />
              <span
                className="text-[10px] sm:text-xs uppercase tracking-[0.2em] font-medium truncate"
                style={{ color: '#8B92A0' }}
              >
                Social Dashboard
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Main */}
      <main
        id="main-content"
        className="flex-1 px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 md:py-8"
        role="main"
      >
        <div className="max-w-7xl mx-auto">{children}</div>
      </main>

      {/* Footer minimal */}
      <footer
        className="px-3 sm:px-4 md:px-6 lg:px-8 py-6"
        style={{
          borderTop: '1px solid #EBEDF1',
          backgroundColor: '#FAFAFB',
        }}
      >
        <div className="max-w-7xl mx-auto text-center">
          <p
            className="text-[10px] sm:text-xs uppercase tracking-[0.18em] font-medium"
            style={{ color: '#8B92A0' }}
          >
            © {new Date().getFullYear()} ByMarke
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
